module.exports = __webpack_public_path__ + "static/grilled-cheese-eb6131ed077093dcbc703a2dc3f748f1.woff2";